import { createGlobalStyle, css } from "styled-components";

/** Nascar Nav injects styles, some of which we can safely disable/offset. */
const NascarOffsets = css`
  h1,
  h2,
  h3 {
    color: inherit;
  }

  button {
    background: inherit;
    color: inherit;
    font: inherit;
  }

  a {
    color: inherit;
    &:hover,
    &:active {
      color: inherit;
    }
  }
`;

const GlobalStyles = createGlobalStyle`
  html,
  body {
    height: 100%;
    background-color: black;
  }

  html {
    ${NascarOffsets}
  }

  #__next {
    height: 100%;
  }
`;

export default GlobalStyles;
